module.exports = __webpack_public_path__ + "static/img/101396.b72fd7b9.png";